import { ReactNode } from 'react'

import { CheckoutHeader, CheckoutWrapper } from './CheckoutContainer.styled'

import LogoImage from '../../assets/images/logo.svg'

type CheckoutContainerProps = {
  className?: string
  children?: ReactNode
}

export const CheckoutContainer = ({ className, children }: CheckoutContainerProps) => (
  <CheckoutWrapper className={className}>
    <CheckoutHeader>
      <span>
        <img src={LogoImage} alt='Logo' />
      </span>
    </CheckoutHeader>

    {children}
  </CheckoutWrapper>
)
